import type { Chapter } from '@code-arcade/engine'

export const chapter5: Chapter = {
  id: 'chapter-5',
  number: 5,
  title: 'Your Money Now',
  company: 'ByteForge',
  devTitle: 'Co-founder / CTO',
  conflict: '5M transactions overnight. Account tiers 1–100. The ETL ran for 4 hours.',
  intro: [
    { character: 'the-algorithm', mood: 'idle', dialogue: 'ByteForge. Your startup. Series A just closed. You are the CTO now.' },
    { character: 'dev-lama', mood: 'idle', dialogue: '5 million transactions to process before market open. Account tiers 1 through 100. Sort by date within each tier.' },
    { character: 'raj-lohani', mood: 'urgent', dialogue: 'The ETL job ran for 4 hours. We have a board meeting in 3. What is happening?' },
    { character: 'dev-lama', mood: 'stressed', dialogue: 'How many unique account tiers are there?' },
    { character: 'raj-lohani', mood: 'idle', dialogue: 'A hundred. Always a hundred.' },
    { character: 'dev-lama', mood: 'happy', dialogue: 'Then we do not need a comparison sort at all. The key space is 100. We know every possible value.' },
    { character: 'the-algorithm', mood: 'idle', dialogue: 'When you know the range of your keys, you can beat O(n log n). Count. Place. Done.' },
  ],
  challengeIds: ['counting-sort'],
}
